// // import React from 'react';
// // import logo from '../../src/Assets/oratricslogo.png';
// // import line from '../../src/Assets/line.jpg';
// // import sign from '../../src/Assets/sign.png'
// // import leftcertificate from '../../src/Assets/newleft1.png'
// // import '../../src/Assets/font/fonts.css';


// // function Cartificatenew() {
// //   const staticStudentName = "Adarsh";

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-10  sm:p-6 lg:p-8 mt font-inter overflow-hidden relative">
    

// //       <div className="w-full max-w-7xl bg-[#f7f4f0] rounded-3xl shadow-xl flex flex-col md:flex-row-reverse overflow-hidden relative z-10">

        
// //         <div className="w-full md:w-1/5  flex ">
// //           <img
// //             src={leftcertificate}
// //             alt="Vertical Decorative Design"
// //             className="absolute inset-0 w-full h-full "
// //             onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/200x800/CCCCCC/000000?text=Image+Error"; }}
// //           />
// //         </div>

// //         <div className="w-full md:w-4/5 p-6 sm:p-8 md:p-12 lg:p-16 flex flex-col justify-between items-center text-center relative">

// //           {/* Top horizontal image - positioned absolutely behind content */}
// //           {/* <img
// //             src="https://placehold.co/800x80/A855F7/FFFFFF?text=TOP+DESIGN" // Placeholder for top image
// //             alt="Top Decorative Design"
// //             className="absolute inset-x-0 top-0 w-full h-20 object-cover opacity-70" // Absolute positioning, fixed height, subtle opacity
// //             onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/800x80/CCCCCC/000000?text=Image+Error"; }}
// //           /> */}
// //           <div className="w-full relative z-20 pt-5">
// //             <img
// //   src={logo}
// //   alt="Oratrics Logo"
// //   className="mx-auto mb-8"
// //   style={{ width: '210px' }}
// // />


// //  <h2
// //   className="text-4xl sm:text-5xl font-bold text-black-600 mt-5"
// //   style={{ fontFamily: "'Cinzel Decorative', serif" }}
// // >
// //   ORATRICS RISING STAR
// // </h2>


// //             <h2
// //   className="text-6xl sm:text-6xl italic font-extrabold text-black-600 mb-8 mt-2"
// //   style={{ fontFamily: 'Certificate Bold, serif' }}
// // >
// //   Certificate
// // </h2>
// //           </div>

// //           <div className="flex-grow flex flex-col justify-center items-center py-8 relative z-20">
// //             <p className="text-xl sm:text-2xl text-gray-700 mb-3">
// //               This certificate is proudly presented to
// //             </p>

// //           <p className="text-3xl sm:text-4xl font-bold text-indigo-900 mb-8 pb-1 border-b-2 border-indigo-500 w-fit px-4"
// //    style={{ fontFamily: "'Great Vibes', cursive" }}>
// //   {staticStudentName}
// // </p>


// //             <p className="text-md sm:text-lg text-gray-800 leading-relaxed max-w-3xl mx-auto px-4 pt-5">
// //               For successfully completing the Oratrics Demo Session and showing exceptional promise in communication, creativity, & confidence.
// //             </p>
// //           </div>

// //           <div className="w-full flex flex-col sm:flex-row justify-between items-end mt-2  relative z-20 pb-10">
// //             <div className="text-left text-gray-600 text-lg">
// //               <p>Date: <span className="font-semibold text-gray-800">June 12, 2025</span></p>
// //             </div>

// //             <div className="text-center sm:text-right text-gray-600 text-lg">
// //               <img
// //                 src={sign}
// //                 alt="Authorized Signatory Signature"
// //                 className="w-28 sm:w-30 mx-auto sm:mx-0 mb-2 object-contain"
// //                 onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/150x50/CCCCCC/000000?text=Sign"; }}
// //               />
// //               <p className="text-sm sm:text-base">Authorized Signatory</p>
// //             </div>
// //           </div>
// //              {/* Bottom horizontal image - positioned absolutely behind content */}
// //           {/* <img
// //             src="https://placehold.co/800x60/6B7280/FFFFFF?text=BOTTOM+DESIGN" // Placeholder for bottom image
// //             alt="Bottom Decorative Design"
// //             className="absolute inset-x-0 bottom-0 w-full h-16 object-cover opacity-60" // Absolute positioning, fixed height, subtle opacity
// //             onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/800x60/CCCCCC/000000?text=Image+Error"; }}
// //           /> */}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }



// // export default Cartificatenew;


// import React from 'react';
// import logo from '../../src/Assets/oratricslogo.png';
// import line from '../../src/Assets/line.jpg';
// import sign from '../../src/Assets/sign.png'
// import leftcertificate from '../../src/Assets/newleft1.png'
// import '../../src/Assets/font/fonts.css';


// function Cartificatenew() {
//  const staticStudentName = "Adarsh";
//   const currentDate = new Date().toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'long',
//     day: 'numeric'
//   });

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-10  sm:p-6 lg:p-8 mt font-inter overflow-hidden relative">
    

//       <div className="w-full max-w-7xl bg-[#f7f4f0] rounded-3xl shadow-xl flex flex-col md:flex-row-reverse overflow-hidden relative z-10">

        
//         <div className="w-full md:w-1/5  flex ">
//           <img
//             src={leftcertificate}
//             alt="Vertical Decorative Design"
//             className="absolute inset-0 w-full h-full "
//             onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/200x800/CCCCCC/000000?text=Image+Error"; }}
//           />
//         </div>

//        <div className="w-full md:w-4/5 p-6 sm:p-8 md:p-12 lg:p-16 flex flex-col justify-between items-center text-center relative">
          
//           {/* Top section with logo and titles */}
//           <div className="w-full relative z-20 pt-5">
//             {/* Oratrics Logo (using placeholder image) */}
//             <img
//               src={logo}// Placeholder for logo
//               alt="Oratrics Logo"
//               className="mx-auto mb-6"
//               style={{ width: '210px' }}
//               onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/210x60/CCCCCC/000000?text=Image+Error"; }}
//             />

//             {/* Title: ORATRICS RISING STAR */}
//             <h2
//               className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 tracking-wide mt-5"
//               style={{ fontFamily: "'Cinzel Decorative', serif" }}
//             >
//               ORATRICS RISING STAR
//             </h2>

//             {/* Subtitle: Certificate */}
//             <h2
//               className="text-5xl sm:text-6xl md:text-7xl italic font-extrabold text-blue-700 mb-8 mt-2"
//               style={{ fontFamily: 'Certificate Bold, serif', textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}
//             >
//               Certificate
//             </h2>
//           </div>

//           {/* Central content section with presentation text and student name */}
//           <div className="flex-grow flex flex-col justify-center items-center py-8 relative z-20">
//             <p className="text-xl sm:text-2xl text-gray-600 mb-4">
//               This certificate is proudly presented to
//             </p>

//             {/* Student Name with enhanced styling */}
//             <p className="text-4xl sm:text-5xl font-bold text-indigo-800 mb-10 pb-2 border-b-4 border-blue-400 w-fit px-6 py-1"
//                style={{ fontFamily: "'Great Vibes', cursive", letterSpacing: '0.05em' }}>
//               {staticStudentName}
//             </p>

//             {/* Description of achievement */}
//             <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto px-4 pt-5">
//               For successfully completing the Oratrics Demo Session and showing exceptional promise in communication, creativity, & confidence.
//             </p>
//           </div>

//           {/* Bottom section with date and signatory details */}
//           <div className="w-full flex flex-col sm:flex-row justify-between items-end mt-4 relative z-20 pb-5">
//             {/* Date */}
//             <div className="text-left text-gray-600 text-lg mb-4 sm:mb-0">
//               <p>Date: <span className="font-semibold text-gray-800">{currentDate}</span></p>
//             </div>

//             {/* Authorized Signatory section with signature image */}
//             <div className="text-center sm:text-right text-gray-600 text-lg">
//               <img
//                 src={sign} // Placeholder for signature image
//                 alt="Authorized Signatory Signature"
//                 className="w-32 sm:w-40 mx-auto sm:mx-0 mb-2 object-contain"
//                 onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/150x50/CCCCCC/000000?text=Sign"; }}
//               />
//               <p className="text-base sm:text-lg text-gray-700 font-medium border-t border-gray-400 pt-1 mt-1">Authorized Signatory</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



// export default Cartificatenew;


import React, { useRef, useState, useEffect } from 'react'; // Import useState and useEffect
import logo from '../../src/Assets/oratricslogo.png';
import sign from '../../src/Assets/sign.png';
import leftcertificate from '../../src/Assets/newleft1.png';
import '../../src/Assets/font/fonts.css'; // Ensure this path is correct
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

function Cartificatenew() {
  const staticStudentName = "Adarsh";
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const certificateRef = useRef(null);
  const [loading, setLoading] = useState(false); // State to manage loading during download

  // Function to handle canvas generation (common for both PDF and PNG)
  const generateCanvas = async () => {
    if (!certificateRef.current) {
      console.warn("Certificate ref is not attached to any element.");
      return null;
    }

    setLoading(true);
    try {
      // html2canvas options:
      // scale: Increase for higher resolution. 3 is a good balance.
      // useCORS: Attempt to load cross-origin images using CORS.
      // allowTaint: Allows images to "taint" the canvas. This is tricky.
      //             If the image truly comes from a different origin WITHOUT CORS headers,
      //             then toDataURL will fail, even with allowTaint.
      //             However, for seemingly local images that act "cross-origin", it *might* help.
      // foreignObjectRendering: Experimental, can help with SVG/foreignObject elements,
      //                       but might cause other issues. Keep off unless necessary.
      const canvas = await html2canvas(certificateRef.current, {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        logging: true, // Enable logging in html2canvas for more debug info in console
        // To specifically handle images, you could pre-load them or ensure their server
        // sends CORS headers. For local assets, usually useCORS/allowTaint isn't needed
        // IF they are correctly bundled and served by webpack/vite from the same origin.
      });
      setLoading(false);
      return canvas;
    } catch (error) {
      console.error("Error generating canvas with html2canvas:", error);
      alert("Failed to prepare certificate for download. Check console for details.");
      setLoading(false);
      return null;
    }
  };

  const generatePdf = async () => {
    const canvas = await generateCanvas();
    if (!canvas) return;

    try {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('landscape', 'px', 'a4'); // 'landscape' for horizontal, 'px' for units, 'a4' for paper size

      const imgWidth = 842; // A4 landscape width in px (approx, adjust as needed)
      const imgHeight = 595; // A4 landscape height in px (approx, adjust as needed)

      // Calculate dimensions to fit the image while maintaining aspect ratio
      const ratio = Math.min(imgWidth / canvas.width, imgHeight / canvas.height);
      const actualWidth = canvas.width * ratio;
      const actualHeight = canvas.height * ratio;
      const x = (imgWidth - actualWidth) / 2;
      const y = (imgHeight - actualHeight) / 2;

      pdf.addImage(imgData, 'PNG', x, y, actualWidth, actualHeight);
      pdf.save(`${staticStudentName}_Certificate.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Check console for details.");
    }
  };

  const generatePng = async () => {
    const canvas = await generateCanvas();
    if (!canvas) return;

    try {
      // Get the image data URL
      const imgData = canvas.toDataURL('image/png');

      // Create a temporary link element to trigger the download
      const link = document.createElement('a');
      link.href = imgData;
      link.download = `${staticStudentName}_Certificate.png`; // Set the download filename
      document.body.appendChild(link); // Append to body (required for Firefox)
      link.click(); // Programmatically click the link
      document.body.removeChild(link); // Clean up the link
    } catch (error) {
      console.error("Error generating PNG:", error);
      alert("Failed to generate PNG. Check console for details.");
    }
  };

  // Optional: Preload images using useEffect to ensure they are in browser cache
  // This can sometimes help html2canvas, though it's often not strictly necessary
  // if assets are bundled correctly.
  useEffect(() => {
    const preloadImages = [logo, sign, leftcertificate];
    preloadImages.forEach(src => {
      const img = new Image();
      img.src = src;
      // img.onload = () => console.log(`Image loaded: ${src}`);
      // img.onerror = () => console.error(`Failed to load image: ${src}`);
    });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-10  sm:p-6 lg:p-8 mt font-inter overflow-hidden relative">

      {/* Download Buttons */}
      <div className="absolute top-4 right-4 flex gap-2 z-50">
        <button
          onClick={generatePdf}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Download PDF'}
        </button>
        <button
          onClick={generatePng}
          className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Download PNG'}
        </button>
      </div>


      {/* Main Certificate Container - Attach the ref here */}
      <div
        ref={certificateRef}
        className="w-full max-w-7xl bg-[#f7f4f0] rounded-3xl shadow-xl flex flex-col md:flex-row-reverse overflow-hidden relative z-10"
      >
        <div className="w-full md:w-1/5 flex">
          <img
            src={leftcertificate}
            alt="Vertical Decorative Design"
            className="absolute inset-0 w-full h-full object-cover"
            onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/200x800/CCCCCC/000000?text=Image+Error"; }}
          />
        </div>

        <div className="w-full md:w-4/5 p-6 sm:p-8 md:p-12 lg:p-16 flex flex-col justify-between items-center text-center relative">

          {/* Top section with logo and titles */}
          <div className="w-full relative z-20 pt-5">
            <img
              src={logo}
              alt="Oratrics Logo"
              className="mx-auto mb-6"
              style={{ width: '210px' }}
              onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/210x60/CCCCCC/000000?text=Image+Error"; }}
            />

            <h2
              className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 tracking-wide mt-5"
              style={{ fontFamily: "'Cinzel Decorative', serif" }}
            >
              ORATRICS RISING STAR
            </h2>

            <h2
              className="text-5xl sm:text-6xl md:text-7xl italic font-extrabold  mb-8 mt-2"
              style={{ fontFamily: 'Certificate Bold, serif', textShadow: '2px 2px 4px rgba(0,0,0,0.1)',color: '#050a30' }}
            >
              Certificate
            </h2>
          </div>

          {/* Central content section */}
          <div className="flex-grow flex flex-col justify-center items-center py-8 relative z-20">
            <p className="text-xl sm:text-2xl text-gray-600 mb-4">
              This certificate is proudly presented to
            </p>

            <p className="text-4xl sm:text-5xl font-bold text-indigo-800 mb-10 pb-2 border-b-4 border-blue-400 w-fit px-6 py-1"
              style={{ fontFamily: "'Great Vibes', cursive", letterSpacing: '0.05em' }}>
              {staticStudentName}
            </p>

            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto px-4 pt-5">
              For successfully completing the Oratrics Demo Session and showing exceptional promise in communication, creativity, & confidence.
            </p>
          </div>

          {/* Bottom section */}
          <div className="w-full flex flex-col sm:flex-row justify-between items-end mt-4 relative z-20 pb-5">
            <div className="text-left text-gray-600 text-lg mb-4 sm:mb-0">
              <p>Date: <span className="font-semibold text-gray-800">{currentDate}</span></p>
            </div>

            <div className="text-center sm:text-right text-gray-600 text-lg">
              <img
                src={sign}
                alt="Authorized Signatory Signature"
                className="w-32 sm:w-40 mx-auto sm:mx-0 mb-2 object-contain"
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/150x50/CCCCCC/000000?text=Sign"; }}
              />
              <p className="text-base sm:text-lg text-gray-700 font-medium border-t border-gray-400 pt-1 mt-1">Authorized Signatory</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cartificatenew;